export default "__VITE_ASSET__BWBmQk1K__"